<template>
  <div class="flex w-full" style="position:relative;">                
      <div v-if="gliders.length" class="d-flex flex-col w-full h-full" >      
        <v-tabs v-if="showTabs" v-model="selectedGliderIdx" align-with-title class="flex-grow-0" >
          <v-tab v-for="(glider,idx) in gliders" :key="glider.id"  :title="glider.libelle" >                  
                {{ glider.libelle }}                  
          </v-tab>                 
        </v-tabs>                
        <MissionDetailScienceGraphicsListGen :uiid="uiid" :isleft="isleft" :mission="selectedMission" :tabState="currentDetailFleet"  @selectGraph="selectGraph($event)" />      
      </div>          
      <div v-else class="w-full h-full flex flex-col mx-4 items-center justify-center title gap-2" >                 
        <span>{{$t('Fleet.NoGliders')}}</span>                            
      </div> 
    </div>  
</template>
<script setup lang="ts">
 
  import { ref,computed, watch, nextTick, onMounted } from 'vue'  
  import store from '@/store'   
  import { AloDbFleet } from '@/models/alodb/AloDbFleet'
  import MissionDetailScienceGraphicsListGen from  '@/components/mission/MissionDetailScienceGraphicsListGen.vue'    

 const props = defineProps<{
   fleet:AloDbFleet, 
   isleft:boolean,
   uiid:string, 
   isVisible:boolean
 }>()
 

  const  missions = computed(()=> props.fleet.param?.missionIds?.map(id => store.myGetters?.missionsById[id])?.filter(m => !!m)?.sort((m,m1) => 
                          !props.fleet.activeMissionIds.includes(m.misId!)?1
                          :!props.fleet.activeMissionIds.includes(m1.misId!)?-1
                          :props.fleet.activeMissionIds.findIndex(misId => m.misId == misId) - props.fleet.activeMissionIds.findIndex(misId => m1.misId == misId)) ?? [])

 
  const gliders = computed(()=> missions.value.map(m => ({id:m.misId,libelle:m.gliKey})))

  const selectedGliderIdx = ref(0)

  const currentDetailFleet = computed(() => store.myGetters.currentDetailFleet)

  async function selectGraph(graph:any){      
     await store.myActions.FLEET_NAVTO_DETAIL({cmp:'FleetDetailScienceGraphics',isleft:!props.isleft,id:-1,'label':graph.name})
     
     const tabsFleet = !props.isleft? currentDetailFleet.value.tabsleft: currentDetailFleet.value.tabsright
     //on attend que le composant soit créé
     nextTick(()=> store.myActions.UI_SET_GRA_CONFIG({config:graph,uiid:tabsFleet.selected}))

  }

  const selectedMission = computed(() => store.myGetters.missionsById[gliders.value[selectedGliderIdx.value].id!])

  watch(selectedMission,()=>{
    if(selectedMission.value?.misId) store.myActions.MISSION_ENSURE_MISSION(selectedMission.value.misId)
  })

  if(selectedMission.value?.misId) store.myActions.MISSION_ENSURE_MISSION(selectedMission.value.misId)

  const showTabs = ref(true)
  onMounted(() => {
    setTimeout(() => {
      showTabs.value = false
      nextTick(() => {
        showTabs.value = true
      })
    }, 100)    
  })

</script>